export const PostTypeIds = Object.freeze({
  ARTICLE: 'article',
  PODCAST: 'podcast',
  LINK: 'link',
  STORIES: 'stories',
  VIDEO: 'video',
});
